import { switchAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  Switch as ChakraSwitch,
  SwitchProps
} from '@chakra-ui/react';
import { forwardRef, LegacyRef } from 'react';
export type { SwitchProps } from '@chakra-ui/react';

export const Switch = forwardRef((props: SwitchProps, ref): JSX.Element => {
  return (
    <ChakraSwitch
      role="switch"
      {...props}
      ref={ref as LegacyRef<HTMLInputElement>}
    />
  );
});

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle(({ theme: { colors } }) => ({
  track: {
    _checked: {
      bg: colors.palette_blue[100]
    }
  }
}));

export const SwitchTheme = defineMultiStyleConfig({ baseStyle });
